import { FaStar } from "react-icons/fa";
import styled from "styled-components";

export const Header = styled.div`
    /* border: 1px solid #f00; */
    margin-top: 30px;

    .row1 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .heading_text {
            letter-spacing: -0.025em;
            line-height: 1;
            font-weight: 600;
            font-size: 1.5rem;
            line-height: 2rem;
            color: var(--primary-text-color);
        }

        .add_video {
            background-color: hsl(265 89% 60% / var(--tw-bg-opacity, 1));
            color: #fff;

            &:hover {
                background-color: hsl(265 89% 60% / 0.9);
            }
        }
    }

    .row2 {
        color: var(--secondary-text-color);

        font-size: 0.875rem;
        line-height: 1.25rem;
    }
`;

export const VideoViews = styled.div`
    margin-top: 30px;

    .header {
        font-weight: 600;
        color: var(--primary-text-color);
    }

    .analytics_chart {
        background-color: rgb(241, 245, 249);
        height: 300px;
        border-radius: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(0, 0, 0, 0.5);
    }
`;

export const GroupPerformanceComparison = styled.div`
    margin-top: 30px;

    .header {
        font-weight: 600;
        color: var(--primary-text-color);
    }

    .display_area {
        display: flex;
        justify-content: space-between;
        gap: 30px;
    }

    .card {
        border: 1px solid var(--border-color);
        border-radius: 15px;
        padding: 15px;

        .name {
            font-weight: 900;
            color: var(--primary-text-color);
        }

        .type {
            font-weight: 900;
            font-size: 2rem;
            color: var(--primary-text-color);
        }

        .info {
            color: rgba(0, 0, 0, 0.3);
            color: var(--secondary-text-color);
        }
    }
`;

export const PatientEngagementByGroup = styled.div`
    margin-top: 30px;

    .header {
        font-weight: 600;
        color: var(--primary-text-color);
    }

    table {
        border: 1px solid var(--border-color);
        border-radius: 8px;
        width: 100%;
        border-collapse: collapse;

        thead {
            color: var(--secondary-text-color);
        }

        th,
        td {
            text-align: left;
            padding: 12px;
            font-size: 0.95rem;
            border-bottom: 1px solid var(--border-color);
        }

        th {
            font-weight: 500;
        }

        td {
            color: var(--primary-text-color);
        }

        .trend {
            color: #10b981; /* green-500 */
            font-weight: 500;
        }
    }
`;

export const Star = styled(FaStar)`
    color: #facc15;
    margin-right: 4px;
`;

export const RatingDistribution = styled.div`
    margin-top: 30px;

    .header {
        font-weight: 600;
        color: var(--primary-text-color);
    }

    .row {
        /* border: 1px solid #f00; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
    }

    .stars {
        display: flex;
        align-items: center;
        gap: 4px;
        min-width: 140px;

        span {
            margin-left: 6px;
            font-size: 0.9rem;
            color: var(--primary-text-color);
        }
    }

    .barWrapper {
        flex: 1;
        height: 8px;
        background: var(--border-color);
        border-radius: 4px;
        margin: 0 12px;
        max-width: 600px;
    }

    .barFill {
        height: 100%;
        background: #a855f7;
        border-radius: 4px;
        transition: width 0.3s ease;
    }

    .percent {
        min-width: 40px;
        text-align: right;
        font-weight: 500;
        color: var(--primary-text-color);
    }
`;
